export default "__VITE_ASSET__CQG6PFxH__"